<template>
  <div class="page">
    <p class="p1">
      个人中心
    </p>
    <p class="p2">
      <span>积分：{{datas.integral}}</span>
      <span>优惠券：无</span>
    </p>
    <div class="mark-box">
      <nut-button @click="openSwitch('isVisible')">切换卡</nut-button>
      <nut-picker :is-visible="isVisible" :list-data="listData" :default-value-data="defaultValueData" @close="closeSwitch('isVisible')" @confirm="confirm"></nut-picker>
    </div>
    <ul class="ul_class">
      <li>
        <nut-cell :show-icon="true" title="我的订单" @click-cell="clickEvnt()"></nut-cell>
      </li>
      <li>
        <nut-cell :show-icon="true" title="我的积分" @click-cell="clickOrder()"></nut-cell>
      </li>
    </ul>
    <div class="div_classs">
      <p>积分说明:</p>
      <p>积分可通过充值获取，1元相对于1积分；</p>
      <p>积分可用于兑换流量；</p>
    </div>
  </div>
</template>

<script>

import { wx_record } from "@/api/api.js"; //获取微信绑定的卡
import { wx_total } from "@/api/api.js"; //获取个人中心页面的积分与默认iccid

export default {
  data() {
    return {
      // 获取数据
      datas:"",
      // 切换卡
      option: '请选择',
      isVisible: false,
      listData: [],
      diData:[],
      defaultValueData: []
    };
  },
  computed: {},
  methods: {
    // 切换卡弹窗
    openSwitch(param) {
      this[`${param}`] = true;
      this.box_xian = false
    },
    // 切换卡弹窗
    closeSwitch(param) {
      this[`${param}`] = false;
      setTimeout(() => {
        this.box_xian = true
      },200)
    },
    parseCallbackUrl(callback, key, val2) {  
      if (!callback) {  
          return '';  
        }  
      let allback = callback.replace(/#$/, '');  
        if (callback.indexOf('?') == -1) {  
          callback = callback + '?' + key + '=' + val2;  
        } else if (callback.indexOf('&' + key + '=') == -1 && callback.indexOf('?' + key + '=') == -1) {  
          callback = callback + '&' + key + '=' + val2;  
        } else {  
          var regExp = new RegExp('([&?]' + key + '=)[^&]*', '');  
          callback = callback.replace(regExp, ('$1' + val2));  
        }  
        return callback;  
    },
    // 切换卡
    confirm(chooseData){
      var url= window.location.href;  
      window.location.href = this.parseCallbackUrl(url,'iccid',`${chooseData[0].value}`)
      location.reload();
    },
    // 订单跳转
    clickEvnt(){
      let params={
        iccid:""
      }
      if(!this.$route.query.iccid){
        params.iccid = this.datas.iccid;
      }else{
        params.iccid = this.$route.query.iccid;
      }
      this.$router.push({
        name: "orderLIst",
        query: {
          iccid: params.iccid,
        }
      });
    },
    // 积分跳转
    clickOrder(){
      let params={
        iccid:""
      }
      if(!this.$route.query.iccid){
        params.iccid = this.datas.iccid;
      }else{
        params.iccid = this.$route.query.iccid;
      }
      this.$router.push({
        name: "integralList",
        query: {
          iccid: params.iccid,
        }
      });
    },
    //获取绑定的数据
    getBangd(){
      let params={
        code:this.code,
        bind:1
      }
      wx_record(params).then(res=>{
        if(res.data.code == 200){
          let arr = res.data.data;
          let obj = {};
          for (let key in arr) {
              obj[key] = arr[key];
          };
          let newObj = Object.keys(obj).map(val => ({
              label: obj[val],
              value: obj[val]
          }));
          this.listData.push(newObj);
        }
      })
    },
    // 获取code
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href;
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },
    // 通过code获取初始化数据
    diyi(){
      let params={
        code:this.code,
      }
      wx_total(params).then(res=>{
        if(res.data.code == 200){
          this.datas = res.data.data;
        }
      })
    }
  },
  created() {
    this.code = this.getUrlParam("code");
    localStorage.setItem("code",this.code);
    this.diyi();
    this.getBangd();
  },
  mounted() {
    window.document.title = "个人中心";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 60px;
      line-height: 60px;
      background: #F94040;
      color: #fff;
      font-size: 16px;
    }
    .p2{
      background: #F94040;
      text-align: center;
      height: 100px;
      line-height: 100px;
      span{
        display: inline-block;
        width: 100px;
        text-align: center;
        font-size: 16px;
        color: #fff;
      }
    }
    .mark-box{
      margin-top: 10px;
      width: 100%;
      height: 50px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        margin-left: 10px;
        background:#F94040;
        border-radius: 5px;
      }
    }
    .div_classs{
      margin-top: 40px;
      padding: 10px;
      p{
        margin-top: 8px;
      }
    }
    .ul_class{
      li{
        margin-top: 10px;
      }
    }
  }

</style>

